import { Table } from "antd";
import React from "react";

const SoftwareVersionsM500 = ({ selectedJob, softwareVersions }) => {
  console.log("selectedJob", selectedJob);

  // Extract displayName and software version values
  const displayName = softwareVersions?.displayName
    ? softwareVersions.displayName
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
    : "";
  const versionsObj = softwareVersions?.values?.["Software Versions"] || {};

  // Define the order and labels for the rows
  // Dynamically generate version rows from the data
  const getVersionRows = (versionsObj) => {
    if (!versionsObj || typeof versionsObj !== "object") return [];
    return Object.entries(versionsObj).map(([key, value]) => ({
      key,
      label: value?.text || key,
    }));
  };

  const versionRows = getVersionRows(versionsObj);

  // Build the table data
  const softwareData = [
    {
      key: "header-1",
      attribute: displayName,
      value: "",
      isHeader: true,
    },
    ...versionRows.map((row, idx) => ({
      key: `row-${idx}`,
      attribute: row.label,
      value: versionsObj[row.key]?.value ?? "",
    })),
  ];

  const columns = [
    {
      title: "",
      dataIndex: "attribute",
      key: "attribute",
      render: (text, record) => {
        if (record.isHeader) {
          return <span style={{ color: "#e03540" }}>{text}</span>;
        }
        return text;
      },
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 2 };
        }
        return {};
      },
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      onCell: (record) => {
        if (record.isHeader) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];

  const calcHeight = -150;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;

  return (
    <div
      className="software-versions-table"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        columns={columns}
        dataSource={softwareData}
        pagination={false}
        bordered={false}
        className="welding-parameters-table"
        showHeader={false}
        scroll={{ y: tableHeight }}
      />
    </div>
  );
};

export default SoftwareVersionsM500;
